import {
  CREATE_PROFILE_FAILED,
  CREATE_PROFILE_START,
  CREATE_PROFILE_SUCCESS,
} from 'constants/action-types/profiles/createProfiles';

export default (state, { type, payload }) => {
  switch (type) {
    case CREATE_PROFILE_START:
      return {
        ...state,
        createProfile: {
          ...state.createProfile,
          loading: true,
          error: null,
        },
      };
    case CREATE_PROFILE_FAILED:
      return {
        ...state,
        createProfile: {
          ...state.createProfile,
          error: payload,
          loading: false,
        },
      };
    case CREATE_PROFILE_SUCCESS:
      return {
        ...state,
        createProfile: {
          ...state.createProfile,
          loading: false,
        },
      };
    default:
      return null;
  }
};
